// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_Tt_","cls2":"ImpactHubModal-cls2_AEW ImpactHubModal-cls1_Tt_"};